import { render, staticRenderFns } from "./AlternativeArticles.vue?vue&type=template&id=366f430c&scoped=true"
import script from "./AlternativeArticles.vue?vue&type=script&lang=js"
export * from "./AlternativeArticles.vue?vue&type=script&lang=js"
import style0 from "./AlternativeArticles.vue?vue&type=style&index=0&id=366f430c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366f430c",
  null
  
)

export default component.exports